
const importMeta = import.meta.env

export const AUTH0_CLIENT_ID = importMeta.VITE_AUTH0_CLIENT_ID
export const AUTH0_DOMAIN = importMeta.VITE_AUTH0_DOMAIN
export const AUTH0_AUDIENCE = importMeta.VITE_AUTH0_AUDIENCE